module.exports = __webpack_public_path__ + "static/media/imagenet1.90666ccb.png";